import { siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200 text-foreground-800 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                琪
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              琪琪影院汇聚电视剧全集、最新电视剧、热门电视剧，韩剧国产剧全覆盖，高清画质在线免费看不缓冲，追剧首选平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">精选专题</a>
              <a href="#media" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">精彩片花</a>
              <a href="#ranking" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热度排行</a>
              <a href="#cards" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">剧集推荐</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">追剧分类</h3>
            <div className="space-y-2">
              <a href="#carousel" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">国产剧</a>
              <a href="#carousel" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">韩剧</a>
              <a href="#index" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">最新电视剧</a>
              <a href="#ranking" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门电视剧</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-300/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">回到顶部</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}